import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import setDocumentTitle, {APP_NAME} from '@/utils/setDocumentTitle';
import ROUTE_TITLES from '@/config/routeTitles';

function useRouteDocumentTitle() {
  const {pathname} = useLocation();

  useEffect(() => {
    const match = ROUTE_TITLES.find(({prefix}) => pathname.startsWith(prefix));
    if (!match) {
      return;
    }

    const routeTitle = match.title ? `${APP_NAME} | ${match.title}` : APP_NAME;
    if (
      document.title === routeTitle ||
      document.title.startsWith(`${routeTitle} >`)
    )
      return;

    if (match.title) {
      setDocumentTitle(match.title);
    } else {
      setDocumentTitle();
    }
  }, [pathname]);
}

export default useRouteDocumentTitle;
